import { Factory } from 'miragejs'
const faker = require('faker');

export const partnerFactory = Factory.extend({
  slug() {
    return faker.datatype.uuid()
  },
  name() {
    return faker.company.companyName()
  },
  description() {
    return faker.commerce.productDescription()
  },
  logo() {
    return faker.image.business()
  },
  logo_negative() {
    return faker.image.business()
  },
  colors() {
    return { primary: faker.internet.color()}
  },
  categories() {
    const category = () => ({
      id: faker.datatype.uuid(),
      name: faker.commerce.department(),
      slug: faker.lorem.slug()
    })
    return Array.from({ length: faker.datatype.number({ min: 1, max: 3 }) }, category)
  },
  campaigns () {
    const campaign = () => ({
      id: faker.datatype.uuid(),
      name: faker.commerce.productName(),
      title: faker.company.catchPhrase(),
      description: faker.lorem.paragraph(),
      important: faker.company.catchPhrase(),
      slug: faker.lorem.slug(),
      howtouse: [ faker.lorem.paragraph(), faker.lorem.paragraph() ],
      end_date: null,
      favorired: faker.datatype.boolean(),
      liked: faker.datatype.boolean(),
      event: 'engagement',
      symbol: null,
      value: null,
      voucher: null,
      partner_slug: faker.lorem.slug(),
      eventData: {
        price: null,
        value: faker.datatype.number({ min: 1, max: 100 }),
        min_value: null,
        max_value: null,
        prices_options: null
      }
    })
    return Array.from({ length: faker.datatype.number({ min: 1, max: 5 }) }, campaign)
  }
})



// WEBPACK FOOTER //
// ./src/mocks/factories/partnerFactory.js